/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';

/**
 * 
 * @export
 * @interface InitiateSoftpayCloudPaymentV2Request
 */
export interface InitiateSoftpayCloudPaymentV2Request {
    /**
     * 
     * @type {number}
     * @memberof InitiateSoftpayCloudPaymentV2Request
     */
    amountMinorUnits: number;
    /**
     * 
     * @type {Currency}
     * @memberof InitiateSoftpayCloudPaymentV2Request
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof InitiateSoftpayCloudPaymentV2Request
     */
    executingLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof InitiateSoftpayCloudPaymentV2Request
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateSoftpayCloudPaymentV2Request
     */
    paymentReference: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitiateSoftpayCloudPaymentV2Request
     */
    sendNotification: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitiateSoftpayCloudPaymentV2Request
     */
    terminalId: string;
}



/**
 * Check if a given object implements the InitiateSoftpayCloudPaymentV2Request interface.
 */
export function instanceOfInitiateSoftpayCloudPaymentV2Request(value: object): value is InitiateSoftpayCloudPaymentV2Request {
    if (!('amountMinorUnits' in value) || value['amountMinorUnits'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('sendNotification' in value) || value['sendNotification'] === undefined) return false;
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    return true;
}

export function InitiateSoftpayCloudPaymentV2RequestFromJSON(json: any): InitiateSoftpayCloudPaymentV2Request {
    return InitiateSoftpayCloudPaymentV2RequestFromJSONTyped(json, false);
}

export function InitiateSoftpayCloudPaymentV2RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateSoftpayCloudPaymentV2Request {
    if (json == null) {
        return json;
    }
    return {
        
        'amountMinorUnits': json['amountMinorUnits'],
        'currency': CurrencyFromJSON(json['currency']),
        'executingLocationId': json['executingLocationId'],
        'orderReference': json['orderReference'],
        'paymentReference': json['paymentReference'],
        'sendNotification': json['sendNotification'],
        'terminalId': json['terminalId'],
    };
}

export function InitiateSoftpayCloudPaymentV2RequestToJSON(json: any): InitiateSoftpayCloudPaymentV2Request {
    return InitiateSoftpayCloudPaymentV2RequestToJSONTyped(json, false);
}

export function InitiateSoftpayCloudPaymentV2RequestToJSONTyped(value?: InitiateSoftpayCloudPaymentV2Request | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amountMinorUnits': value['amountMinorUnits'],
        'currency': CurrencyToJSON(value['currency']),
        'executingLocationId': value['executingLocationId'],
        'orderReference': value['orderReference'],
        'paymentReference': value['paymentReference'],
        'sendNotification': value['sendNotification'],
        'terminalId': value['terminalId'],
    };
}

